import {
  AppConfigApi,
  ArtistApi,
  AssetApi,
  AuthApi,
  CollectionsApi,
  EmailApi,
  EventsApi,
  LaunchPadApi,
  NftsApi,
  OrdersApi,
  ProjectsApi,
  TransactionsApi,
  UpdatesApi,
  ViewerApi,
  WalletApi,
  WhitelistApi,
} from '@mogul/api-client';
import { bindApiConfig } from '@mogul/shared';

import { authMachine } from './auth';
import { apiBase } from './config';

const defaults = {
  basePath: apiBase,
  accessToken: async () => (await authMachine.getAccessToken()) ?? '',
};

export const authApiFactory = bindApiConfig(defaults, AuthApi);
export const assetApiFactory = bindApiConfig(defaults, AssetApi);
export const eventsApiFactory = bindApiConfig(defaults, EventsApi);
export const projectsApiFactory = bindApiConfig(defaults, ProjectsApi);
export const nftsApiFactory = bindApiConfig(defaults, NftsApi);
export const updatesApiFactory = bindApiConfig(defaults, UpdatesApi);
export const viewerApiFactory = bindApiConfig(defaults, ViewerApi);
export const appConfigApiFactory = bindApiConfig(defaults, AppConfigApi);

export const emailApiFactory = bindApiConfig(defaults, EmailApi);
export const walletApiFactory = bindApiConfig(defaults, WalletApi);
export const collectionsApiFactory = bindApiConfig(defaults, CollectionsApi);
export const transactionsApiFactory = bindApiConfig(defaults, TransactionsApi);
export const artistApiFactory = bindApiConfig(defaults, ArtistApi);
export const launchPadApiFactory = bindApiConfig(defaults, LaunchPadApi);
export const whitelistApiFactory = bindApiConfig(defaults, WhitelistApi);
export const ordersApiFactory = bindApiConfig(defaults, OrdersApi);

export const appConfigApi = appConfigApiFactory();
export const assetApi = assetApiFactory();
export const authApi = authApiFactory();
export const eventsApi = eventsApiFactory();
export const projectsApi = projectsApiFactory();
export const nftsApi = nftsApiFactory();
export const updatesApi = updatesApiFactory();
export const viewerApi = viewerApiFactory();
export const whitelistApi = whitelistApiFactory();

export const emailApi = emailApiFactory();
export const walletApi = walletApiFactory();
export const collectionsApi = collectionsApiFactory();
export const transactionsApi = transactionsApiFactory();
export const artistApi = artistApiFactory();
export const launchPadApi = launchPadApiFactory();
export const ordersApi = ordersApiFactory();
